import React from 'react';

const Female: React.FC = () => {
  return (
    <svg viewBox="0 0 40 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.36001 48.38L0.0100098 34.79L39.41 32.67L32.65 51L5.36001 48.38Z" />
      <path d="M19.47 29.9C24.8327 29.9 29.18 25.5527 29.18 20.19C29.18 14.8273 24.8327 10.48 19.47 10.48C14.1073 10.48 9.76001 14.8273 9.76001 20.19C9.76001 25.5527 14.1073 29.9 19.47 29.9Z" />
      <path d="M25.23 9.89001L21.28 8.34001L22.2 5.70001L26.49 6.72001L25.23 9.89001Z" />
      <path d="M22.71 4.15L24.49 1.37L33.49 0.559998L39.12 8.82L36.06 18.34L39.99 17.73L37.06 21.83L32.89 19.68L28.26 11.46L28.8 4.72L22.71 4.15Z" />
    </svg>
  );
};

export { Female };
